module.exports = __webpack_public_path__ + "static/img/zt5888340.acdfaf97.png";